import { BASE_FLOW_BUILDER_API_URL } from 'components/flowBuilder/constants';

export const FLOWS_INFO = '/v2/flowbuilder/flows/[guid]/info/';
export const SEND_MESSAGE_TEST_API_URL = `${BASE_FLOW_BUILDER_API_URL}actions/message/test/`;
export const MESSAGE_FIELD_PREVIEW = `${BASE_FLOW_BUILDER_API_URL}actions/field/preview/`;
